import MenuRoundedIcon from "@mui/icons-material/MenuRounded";

export const menu = (props) => {
  return <MenuRoundedIcon {...props} />;
};
